import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { PageOne, PageTwo } from './components';
;
export const DocumentEight = memo(({ pharmacy, traderInfo, }) => (_jsxs(_Fragment, { children: [_jsx(PageOne, {}), _jsx(PageTwo, { pharmacy: pharmacy, traderInfo: traderInfo })] })));
